import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Works from "./Pages/Works";
import personalData from "./config/personalData";

const MAINTENANCE_MODE = false;

export default function App() {
  if (MAINTENANCE_MODE) {
    return (
      <main
        className="flex min-h-screen items-center justify-center px-6"
        style={{ backgroundColor: "#F9F6EE", color: "#4A4A4A" }}
      >
        <section className="w-full max-w-xl text-center">
          <h1 className="font-bodoni text-5xl leading-none sm:text-7xl">
            In the works.
          </h1>

          <p
            className="mt-5 text-sm italic tracking-wide sm:text-base"
            style={{ color: "#8A8173" }}
          >
            Live soon.
          </p>

          <div aria-hidden="true" className="mt-9 flex items-center justify-center gap-3">
            <span className="h-px w-10 bg-[#D8D2C4]" />
            <span className="h-1.5 w-1.5 rounded-full bg-[#8A8173]" />
            <span className="h-px w-10 bg-[#D8D2C4]" />
          </div>
        </section>
      </main>
    );
  }

  const { theme } = personalData;
  const debugMotion =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("debug-motion");

  return (
    <div
      className={`min-h-screen font-lora-regular ${debugMotion ? "debug-motion" : ""}`}
      style={{
        background:
          "linear-gradient(180deg, #F9F6EE 0%, #F9F6EE 55%, #F9F6EE 100%)",
        color: theme.colors.text,
      }}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/works" element={<Works />} />
      </Routes>
    </div>
  );
}
